// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
const RESOURCE_NAME = '/hazmat-code';

export default {
  getHazmatCodes() {
    return axios.get(`${RESOURCE_NAME}/get`);
  },
};
